import { Injectable } from '@angular/core';
import { ILocation } from '@models/interfaces/ILocation';
import { MapToolsService, ToggleTool, ToolBase, ToolName } from '@techwan/map-tools';
import { Subscription } from 'rxjs';
import { LocalizePositionService } from '../localize-position/localize-position.service';
import { MapShowAddressService } from '../map-show-address/map-show-address.service';
import { MyCardButtonsControllerService } from './my-card-buttons-controller/my-card-buttons-controller.service';
import { MyLocationButtonsControllerService } from './my-location-buttons-controller/my-location-buttons-controller.service';

@Injectable()
export class InMapPanelService {
  private _routeButton: ToggleTool = null;
  get routeButton(): ToggleTool {
    return this._routeButton;
  }

  private _fullscreenButton: ToggleTool = null;
  get fullscreenButton(): ToggleTool {
    return this._fullscreenButton;
  }

  private removeLocationButton: ToolBase = null;
  private localizeLocationButton: ToolBase = null;

  private readonly subs: Subscription[] = [];

  constructor(
    private mapToolsService: MapToolsService,
    private myCardButtonsController: MyCardButtonsControllerService,
    private myLocationButtonsController: MyLocationButtonsControllerService,
    private localizePositionService: LocalizePositionService,
    private mapShowAddress: MapShowAddressService
  ) {}

  setup() {
    this.mapToolsService.setup();
    this.myCardButtonsController.init();
    this.myLocationButtonsController.init();
    this.initButtons();

    this.subs.push(this.mapShowAddress.$event.subscribe(address => this.onShowAddress(address)));
    this.subs.push(this.removeLocationButton.$event.subscribe(() => this.onRemoveLocation()));
    this.subs.push(
      this.localizeLocationButton.$event.subscribe(() =>
        this.localizePositionService.localize({ coordinates: [this.mapShowAddress.currentAddress.coordinate], target: null })
      )
    );

    this.hideButton(this.mapToolsService.getTool(ToolName.ToggleDeployment) as ToggleTool);
    this.hideButton(this.routeButton);
  }

  private initButtons() {
    this._routeButton = this.mapToolsService.getTool(ToolName.DrawAndRemoveRoute) as ToggleTool;
    this._fullscreenButton = this.mapToolsService.getTool(ToolName.Fullscreen) as ToggleTool;
    this.removeLocationButton = this.mapToolsService.getTool(ToolName.RemoveLocation) as ToolBase;
    this.localizeLocationButton = this.mapToolsService.getTool(ToolName.LocalizeLocation) as ToolBase;
  }

  private onShowAddress(address: ILocation) {
    if (address !== null) {
      this.showButton(this.removeLocationButton);
      this.showButton(this.localizeLocationButton);
    } else {
      this.hideButton(this.removeLocationButton);
      this.hideButton(this.localizeLocationButton);
    }
  }

  private onRemoveLocation() {
    this.mapShowAddress.clear();
  }

  setDown() {
    this.myLocationButtonsController.uninit();
    this.myCardButtonsController.uninit();
    this.mapToolsService.cleanup();

    while (this.subs.length > 0) {
      this.subs.pop().unsubscribe();
    }
  }

  hideButton(tool: ToolBase) {
    this.mapToolsService.hideTool(tool);
  }

  showButton(tool: ToolBase) {
    this.mapToolsService.showTool(tool);
  }
}
